/**
 * @desc We need this to evaluate all the scripts that b2c add to the components banners and pages
 * @param html
 * @return {any}
 * @private
 */
import {isOrbitInQAMode} from '../../../../utils/qa-mode-utils';
import {isInsideAutomation} from '../../../../utils/automation-helpers';

export function evaluateScripts(html: string): void {

  if(!html) {
    return;
  }

  /**
    Webpack dev server returns the public/index.html instead of 404 for calls like api/pagecontent.
    When this happens this function basically will execute the script in the public/index.html.
    And that script is launcher.min.js. So basically we will try to load again orbit and sdk and this will fail.
  */
  if (0 <= html.indexOf('<!--WE NEED THIS COMMENT IN evaluateScripts FUNCTION TO PREVENT RELOADING THE APP TWICE-->')) {
    return;
  }

  let scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;

  // Remove comment from the html(so we don't run scripts in comment),
  html = html.replace(/<!--[\s\S]*?-->/g, "");
  let match = scriptRegex.exec(html);

  while (match) {
    try {
      evaluateScriptsWithExternalFile(match[0]);
      match = scriptRegex.exec(html);
    } catch (err) {
      if(!isInsideAutomation()) {
        console.error('Failed to load script!', match, err);
      }

    }
  }
}

/**
 * Evaluate scripts with external file. ex: <script type="text/javascript" language="JavaScript" src="/EN/JS/main-files/promotions-lobby.js"></script>
 */
function evaluateScriptsWithExternalFile(html: string) {
  try {
    const fakeDiv = document.createElement('div');
    fakeDiv.innerHTML = html.trim();

    const scriptElements = fakeDiv.getElementsByTagName('script');
    const elementsLength = scriptElements ? scriptElements.length : 0;

    for (let index = 0; index < elementsLength; index++) {
      const script = document.createElement("script");

      if (scriptElements[index]['src']) {
        script.src = scriptElements[index]['src'];
      } else {
        //Add try catch to B2C scripts
        const tryStart = "try{";
        const consoleLogFunc = (isOrbitInQAMode() ? 'warn' : 'error');
        const tryEnd = `}catch(e){console.${consoleLogFunc}('B2C ERROR In EXTERNAL SCRIPT, ERROR MESSAGE: ', e)}`;

        script.innerHTML = tryStart + scriptElements[index]['innerHTML'] + tryEnd;

      }

      document.head.appendChild(script).parentNode?.removeChild(script);
    }
  } catch (err) {
    if(!isInsideAutomation()) {
      console.log('Error in evaluateScriptsWithExternalFile function, err message:', err);
    }

  }
}
